import gql from 'graphql-tag'

export const Q_GET_PENALTIES = gql`
  query {
    penalties {
      id
      offenseTypeId
      offenseCount
      penaltyType
      noticeTypeId
      penaltyDays
      customExpirationMonths
      template
      offenseType {
        name
      }
      noticeType {
        name
      }
    }
  }
`

export const M_CREATE_PENALTY = gql`
  mutation(
    $offenseTypeId: Int!
    $offenseCount: Int!
    $penaltyType: PenaltyType!
    $noticeTypeId: Int
    $penaltyDays: Int
    $customExpirationMonths: Int
    $template: String
  ) {
    createPenalty(
      offenseTypeId: $offenseTypeId
      offenseCount: $offenseCount
      penaltyType: $penaltyType
      noticeTypeId: $noticeTypeId
      penaltyDays: $penaltyDays
      customExpirationMonths: $customExpirationMonths
      template: $template
    ) {
      id
      offenseTypeId
      offenseCount
      penaltyType
      noticeTypeId
      penaltyDays
      customExpirationMonths
      template
    }
  }
`

export const M_UPDATE_PENALTY = gql`
  mutation(
    $id: Int!
    $offenseTypeId: Int
    $offenseCount: Int
    $penaltyType: PenaltyType
    $noticeTypeId: Int
    $penaltyDays: Int
    $customExpirationMonths: Int
    $template: String
  ) {
    updatePenalty(
      id: $id
      offenseTypeId: $offenseTypeId
      offenseCount: $offenseCount
      penaltyType: $penaltyType
      noticeTypeId: $noticeTypeId
      penaltyDays: $penaltyDays
      customExpirationMonths: $customExpirationMonths
      template: $template
    ) {
      id
      offenseTypeId
      offenseCount
      penaltyType
      noticeTypeId
      penaltyDays
      customExpirationMonths
      template
    }
  }
`

export const M_DELETE_PENALTY = gql`
  mutation($where: PenaltyWhereInput!) {
    deletePenalty(where: $where)
  }
` 